var map = {
	"./Application.jpg": 2232,
	"./Game.jpg": 2233,
	"./Music.jpg": 2234,
	"./Video.jpg": 2235,
	"./Wallpaper.jpg": 2236,
	"./Yummy Recipe.jpg": 2237,
	"./Yummy-Recipe.jpg": 2238
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2231;


//////////////////
// WEBPACK FOOTER
// ./src/assets/cutemobi/imgs/browse ^\.\/.*\.jpg$
// module id = 2231
// module chunks = 0